import type { HasarTuru } from '@kurultay/tipler'
import type { Rastgele } from './rastgele.js'
import denge from '../denge/temel.json' with { type: 'json' }

export interface SaldiriGirdisi {
  saldiri: number
  /** Beceri hasar çarpanı. 1 = temel saldırı. */
  carpan: number
  hasarTuru: HasarTuru
  kritikSansi: number
  isabet: number
}

export interface SavunmaGirdisi {
  zirh: number
  ruhDirenci: number
  kacinma: number
}

export interface HasarSonucu {
  hasar: number
  kritik: boolean
  isabetEtti: boolean
}

/**
 * Hasar türü hangi savunmaya bakılacağını belirler.
 * Ruh hasarı zırhı hiç dikkate almaz — Kargıcı/Tırpan'ın "zırhı yok sayar"
 * özelliği bu ayrımdan doğar, ayrı bir kural gerekmez.
 */
function savunmaDegeri(tur: HasarTuru, h: SavunmaGirdisi): number {
  return tur === 'fiziksel' ? h.zirh : h.ruhDirenci
}

function isabetOrani(isabet: number, kacinma: number): number {
  const ham = isabet / (isabet + kacinma || 1)
  return Math.min(denge.azamiIsabetOrani, Math.max(denge.asgariIsabetOrani, ham))
}

export function hasarHesapla(
  s: SaldiriGirdisi,
  h: SavunmaGirdisi,
  r: Rastgele,
): HasarSonucu {
  if (!r.sans(isabetOrani(s.isabet, h.kacinma))) {
    return { hasar: 0, kritik: false, isabetEtti: false }
  }

  const savunma = savunmaDegeri(s.hasarTuru, h)
  const azaltma = savunma / (savunma + denge.savunmaSabiti)
  let hasar = s.saldiri * s.carpan * (1 - azaltma)

  const kritik = r.sans(s.kritikSansi)
  if (kritik) hasar *= denge.kritikCarpani

  // İsabet eden vuruş en az 1 hasar verir; aksi halde aşırı zırh savaşı kilitler.
  return { hasar: Math.max(1, Math.round(hasar)), kritik, isabetEtti: true }
}

export { denge as DENGE }
